import { css } from '@emotion/react';
import { removeParamsFromUrl } from '@zapier/url-utils';

import { Alert, Button, Link, Text } from '@zapier/design-system';

import { AuthLayout } from '../AuthLayout';

type Props = {
  error: string | undefined | null;
  url: string;
};

const rootStyle = css`
  display: grid;
  grid-gap: 20px;
`;

const buttonStyle = css`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 20px;
`;

function humanReadableError(error: string) {
  if (error.includes('Not a valid UUID')) {
    return 'Could not find invitation';
  }

  return error;
}

export function InvitationError({ error, url }: Props) {
  const query = url.split('?')?.[1] || '';
  const params = removeParamsFromUrl(`?${query}`, ['invitation']);

  const errorMessage = error
    ? humanReadableError(error)
    : 'This invitation is no longer valid';

  return (
    <AuthLayout promo={null} showPromo={false} title={null}>
      <div css={rootStyle}>
        <Text tag="h1" type="pageHeader5" color="neutral800">
          Oh no!
        </Text>
        <Text tag="h2" type="sectionHeader3" color="neutral800">
          Something went wrong
        </Text>
        <div />
        <Alert type="error">{errorMessage}</Alert>
        <div />
        <div css={buttonStyle}>
          <Link href={`/sign-up${params}`}>
            <Button isFullWidth={true} presentationOnly={true} size={'small'}>
              Sign up
            </Button>
          </Link>
          <Link href={`/app/login${params}`}>
            <Button
              color="secondary"
              isFullWidth={true}
              presentationOnly={true}
              size={'small'}
            >
              Log in
            </Button>
          </Link>
        </div>
      </div>
    </AuthLayout>
  );
}
